import { render, staticRenderFns } from "./MetricsTopDiagnosis.vue?vue&type=template&id=3f786d5c"
import script from "./MetricsTopDiagnosis.vue?vue&type=script&lang=js"
export * from "./MetricsTopDiagnosis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports